import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = '/api/promotions/dealer/lucky-draws'
const QUERY_KEY = 'lucky-draw'

export const useGetDealerLuckyDraws = (params = {}, config = {}) =>
  useQuery(
    [`${QUERY_KEY}s`, params],
    async () => (await axios.get(ENDPOINT, { params })).data,
    config
  )

export const useGetDealerLuckyDrawById = (id, config = {}) =>
  useQuery([QUERY_KEY, id], async () => (await axios.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetDealerLuckyDrawCanSubmit = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'form', 'can-submit'],
    async () => (await axios.get(`${ENDPOINT}/form/can-submit`)).data,
    config
  )

export const usePostDealerLuckyDraw = (config = {}) =>
  useMutation((newData) => axios.post(ENDPOINT, newData), config)

export const usePatchDealerLuckyDrawApprove = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/approve`, updatedData), config)

export const usePatchDealerLuckyDrawReject = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/reject`, updatedData), config)

export const usePostExportDealerLuckyDraw = (config = {}) =>
  useMutation(() => axios.post(`${ENDPOINT}/export`, null, { responseType: 'blob' }), config)

export const usePostResendSMSDealerLuckyDraw = (id, config = {}) =>
  useMutation(() => axios.post(`${ENDPOINT}/${id}/resend-sms`, null), config)
